import React, { createContext, useContext, useState, useEffect } from 'react';

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
    const [tokenData, setTokenData] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const baseUrl = process.env.REACT_APP_API_URL;
    const userID = localStorage.getItem('user_id');
    const accessToken = localStorage.getItem('access_token');

    const checkToken = async () => {
        try {
            const response = await fetch(`${baseUrl}/users/${userID}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                const data = await response.json();
                setTokenData(data);
                setIsAuthenticated(true);
            } else {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_id');
                localStorage.removeItem('user_type');
                setIsAuthenticated(false);
            }
        } catch (error) {
            console.error('Erro ao verificar token:', error);
            setIsAuthenticated(false);
        }
    };

    useEffect(() => {
        if (userID && accessToken) {
            checkToken();
        } else {
            setIsAuthenticated(false);
        }
    }, [userID, accessToken]);

    return (
        <TokenContext.Provider value={{ tokenData, isAuthenticated, checkToken }}>
            {children}
        </TokenContext.Provider>
    );
};

export const useToken = () => useContext(TokenContext);